import { nanoid } from 'nanoid';
import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import FixedView from '../../components/FixedView';
import FormViewer from '../../components/FormViewer';
import FieldItem from '../../components/inputs/FieldItem';
import SelectInput from '../../components/inputs/SelectInput';
import TextAreaInput from '../../components/inputs/TextAreaInput';
import TextInput from '../../components/inputs/TextInput';
import LoaderButton from '../../components/LoaderButton';
import Responsive from '../../components/Responsive';
import { getBoundingClientRect } from '../../utils/functions';
import { checkTranslation, translate } from '../../utils/useful';
import MultiStage from './MultiStage';
import CAHeader from '../../components/header/CAHeader';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import DiagramPath from '../../components/views/diagram/DiagramPath';
import PermissionsView from '../../components/PermissionsView';

class WorkflowViewer extends React.Component {
    state = {

        paths: [],

        stages: [],
        stageName: '',

        data: {},
        components: {},

        // rawStages: [
        //     { id: 0, to: [1], name: '{{lang}}Trigger', type: 'trigger', color: { background: 'rgb(224,233,255)', text: '#000' } },
        //     { id: 1, to: [2,], name: '{{lang}}Not started', color: { background: 'rgb(224,233,255)', text: '#000' } },
        //     { id: 2, to: [4, 3], name: '{{lang}}In progress', color: { background: 'rgb(254,231,205)', text: '#000' } },
        //     { id: 3, to: [6, 7, 5], name: '{{lang}}Stage3', color: { background: 'rgb(254,226,242)', text: '#000' } },
        //     { id: 4, to: [9], name: '{{lang}}Stage4', color: { background: '#F3D7CA', text: '#000' } },
        //     { id: 5, to: [9], name: '{{lang}}Stage5', color: { background: '#D2E9E9', text: '#000' } },
        //     { id: 6, to: [9], name: '{{lang}}Stage6', color: { background: '#D5F0C1', text: '#000' } },
        //     { id: 7, to: [8], name: '{{lang}}Stage7', color: { background: '#AAD9BB', text: '#000' } },
        //     { id: 8, to: [9], name: '{{lang}}Stage8', color: { background: '#F5E8DD', text: '#000' } },
        //     { id: 9, to: [10], name: '{{lang}}Finished', color: { background: '#F1EAFF', text: '#000' } },
        //     { id: 10, name: '{{lang}}Archive', color: { background: '#D2E9E9', text: '#000' } },
        // ],


    }

    componentDidMount() {


        setTimeout(() => {
            this.init()
        }, 10)

    }


    init = () => {
        this.createStagesHiarchie()

    }

    lastStage = () => {
        if (this.props.customBackAction) {
            this.props.customBackAction()
        } else {
            this.props.lastStage()
        }
    }

    createStagesHiarchie = (cb) => {
        if (this.props.stages) {
            let inList = []
            let finalHiarchie = []

            let stages = JSON.parse(JSON.stringify([...this.props.stages]))
            let rawStages = JSON.parse(JSON.stringify([...this.props.stages]))

            let parent


            for (let i = 0; i < stages.length; i++) {
                const element1 = stages[i];
                let found = false
                for (let index = 0; index < stages.length; index++) {
                    const element2 = stages[index];
                    if (element2.to && element2.to.includes(element1.id)) {
                        found = true
                    }
                }
                if (!found) {
                    parent = element1

                }
            }


            this.findParents(parent, stages)
            this.findSibilingLevel(stages)


            let hiarchie = { stage: parent, children: [] }

            this.getStageChildren(parent, hiarchie.children, stages, inList)



            finalHiarchie.push(hiarchie)



            this.setState({ finalHiarchie, stages: rawStages }, () => {
                setTimeout(() => {
                    this.createPaths(stages, () => {
                        let currentId = this.props.currentStage?.id
                        if (currentId && this['component-' + currentId]) {
                            let bound = getBoundingClientRect(this['component-' + currentId])
                            let containrBound = getBoundingClientRect(this.container)

                            this.container.scrollTo({ left: bound.left - containrBound.left - 20 })

                        }
                        if (cb) {
                            cb()
                        }
                    })

                }, 20);
            })
        }
    }



    createPaths = (stages, cb) => {

        // let stages = this.state.stages
        let paths = []
        let containerBound = getBoundingClientRect(this.container)
        let bounds = {}

        for (let index = 0; index < stages.length; index++) {
            const stage = stages[index];
            let component = this['component-' + stage.id]
            if (component) {

                let bound = getBoundingClientRect(component)
                bounds[stage.id] = bound
                // console.log(bound)
            }
        }

        let scrollLeft = this.container?.scrollLeft
        let scrollTop = this.container?.scrollTop


        for (let index = 0; index < stages.length; index++) {
            const stage = stages[index];
            let start = [(bounds[stage.id]?.left + bounds[stage.id]?.width - containerBound.left) + scrollLeft, (bounds[stage.id]?.top + (bounds[stage.id]?.height / 2) - containerBound.top) + scrollTop]
            let SCKey = stage.id


            if (Array.isArray(stage.to)) {
                for (let j = 0; j < stage.to.length; j++) {
                    const to = stage.to[j];
                    let end = [bounds[to]?.left - containerBound.left - 1 + scrollLeft, (bounds[to]?.top + (bounds[to]?.height / 2) - containerBound.top + scrollTop)]
                    let ECKey = to

                    if (end && start) {
                        paths.push({ ECKey, SCKey, start, end, startOffset: [0, 0], endOffset: [0, 0] })
                    }
                }
            }


        }



        this.setState({ paths }, () => {
            cb()
        })
        // console.log(paths)

    }



    findSibilingLevel = (stages) => {
        for (let i = 0; i < stages.length; i++) {
            let stage = stages[i];

            if (stage.parents?.length > 1) {
                let oneParent = stage.parents[0]

                for (let j = 0; j < oneParent.length; j++) {
                    const oneStage = oneParent[j];
                    let found = true

                    for (let k = 0; k < stage.parents.length; k++) {
                        const otherParent = stage.parents[k];
                        if (!otherParent.includes(oneStage)) {
                            found = false
                        }
                    }

                    if (found) {

                        let isParent = false
                        for (let m = 0; m < stages.length; m++) {
                            const parentStage = stages[m];
                            if (parentStage.id == oneStage && parentStage.to.includes(stage.id)) {
                                isParent = true
                            }
                        }


                        // if (!isParent) {


                        stage.sibiling = oneStage
                        // }
                    }
                }

            }

        }


        for (let i = 0; i < stages.length; i++) {
            let stage = stages[i];

            if (stage.sibiling) {

                for (let j = 0; j < stages.length; j++) {
                    let otherStage = stages[j];

                    if (stage.sibiling == otherStage.id) {
                        if (!otherStage.sibilings) {
                            otherStage.sibilings = []
                        }
                        otherStage.sibilings.push({ stage, children: [] })
                    }


                }

            }
        }
    }

    findParents = (cStage, stages) => {

        if (cStage) {
            for (let i = 0; i < stages.length; i++) {
                let stage = stages[i];

                if (Array.isArray(stage.to) && stage.to.includes(cStage.id)) {

                    if (!cStage.parents) {
                        cStage.parents = []
                    }
                    if (!stage.parents || stage.parents.length == 0) {
                        cStage.parents.push([stage.id])

                    } else {
                        for (let j = 0; j < stage.parents.length; j++) {

                            const mpath = stage.parents[j];
                            // let found = false

                            if (Array.isArray(mpath)) {

                                // let nParent = [...mpath, stage.id]
                                // for (let k = 0; k < cStage.parents.length; k++) {
                                //     const pparent = cStage.parents[k];
                                //     if (String(pparent) == String(nParent)) {
                                //         found = true
                                //     }
                                // }
                                // if (!found) {
                                cStage.parents.push([...mpath, stage.id])
                                // }


                            }

                        }
                    }
                }

                if (Array.isArray(cStage.parents)) {
                    let stageParents = [...cStage.parents]
                    cStage.parents = []

                    for (let m = 0; m < stageParents.length; m++) {
                        const element1 = stageParents[m];
                        let found = false
                        for (let n = 0; n < stageParents.length; n++) {
                            const element2 = stageParents[n];

                            if (m != n) {
                                found = element1.every(v => element2.includes(v))
                            }
                        }
                        if (!found) {
                            cStage.parents.push(element1)
                        }

                    }
                }
            }

            if (Array.isArray(cStage.to)) {
                for (let i = 0; i < cStage.to.length; i++) {
                    const stage = cStage.to[i];
                    for (let j = 0; j < stages.length; j++) {
                        const element = stages[j];
                        if (stage == element.id) {
                            this.findParents(element, stages)
                        }
                    }
                }
            }
        }

    }



    getStageChildren(parent, hiarchie, stages, inList) {
        if (parent && parent.to) {

            for (let i = 0; i < stages.length; i++) {
                const element = stages[i];


                if (parent.to.includes(element.id)) {

                    if (!inList.includes(element.id) && (element.sibiling == null)) {
                        inList.push(element.id)
                        let myHiarchie = { stage: element, children: [] }

                        this.getStageChildren(element, myHiarchie.children, stages, inList)

                        hiarchie.push(myHiarchie)

                    }
                }

            }
        }

        if (parent?.sibilings) {
            for (let i = 0; i < parent.sibilings.length; i++) {
                let thisStage = parent.sibilings[i];
                this.getStageChildren(thisStage.stage, thisStage.children, stages, inList)
                // console.log(thisStage)
            }
        }
    }






    selectHandler = (item) => {
        let defaultt = this.state.stages;
        defaultt.push(item);
        this.makeList()
        this.setState({ stages: defaultt }, this.createStage.hideView());
    };

    makeList = () => {
        let defaultt = this.state.stages
        let stages = []
        this.props.headers.forEach(e => {
            if (!defaultt.includes(e)) {
                if (!stages.includes(e)) {
                    stages.push(e)

                }
            }
        });
        this.setState({ stages })

    }





    removeCurrentStage = () => {
        let currentStage = this.state.currentStage
        let stages = this.state.stages
        let foundIndex

        stages.forEach((stage, index) => {
            if (stage.id == currentStage.id) {
                foundIndex = index
            }
        })

        if (foundIndex != null) {
            stages.splice(foundIndex, 1)
        }


        for (let i = 0; i < stages.length; i++) {
            let stage = stages[i];
            if (!Array.isArray(stage.to)) {
                stage.to = []
            }

            if (stage.to.includes(currentStage.id)) {
                stage.to = stage.to.filter((a) => a != currentStage.id)
                let to = currentStage.to ?? []
                stage.to = this.uniqueById([...stage.to, ...to])
            }

        }


        this.setState({ currentStage: null, stages }, () => {
            this.createStagesHiarchie()
        })
    }


    uniqueById(items) {
        const set = new Set();
        return items.filter((item) => {
            const isDuplicate = set.has(item.id);
            set.add(item.id);
            return !isDuplicate;
        });
    }


    stagePathDrop = (path) => {

        let stages = this.state.stages
        let draggingStage = this.state.draggingStage

        for (let i = 0; i < stages.length; i++) {
            let stage = stages[i];
            if (!Array.isArray(stage.to)) {
                stage.to = []
            }

            if (stage.to.includes(draggingStage.id)) {
                stage.to = stage.to.filter((a) => a != draggingStage.id)
                let to = draggingStage.to ?? []
                stage.to = [...stage.to, ...to]
            }

            if (stage.id == path.SCKey) {
                stage.to = stage.to.filter((a) => a != path.ECKey)
                stage.to.push(draggingStage.id)
            }

            if (stage.id == draggingStage.id) {

                stage.to = []
                stage.to.push(path.ECKey)

            }
        }


        this.setState({ stages: stages, draggingStage: null, ghost: null }, () => {
            this.createStagesHiarchie()
        })

    }



    changeValue = (event, index) => {
        let stages = this.state.stages
        stages[index].name = event.target.value
        this.setState({ stages })
    }
    setData = (key, value) => {
        let defaultt = this.state.stages
        for (let i = 0; i < defaultt.length; i++) {
            if (defaultt[i].id == key.id) {
                defaultt.splice(i, 1, value)
                break
            }
        }
        this.setState({ stages: defaultt })

    }
    addActions = (key, index) => {

        let stages = this.state.stages
        stages[index].type = key
        this.setState({ stages })
    }


    setStage = (item) => {
        return

    }


    renderSection(hiarchie) {

        if (hiarchie && Array.isArray(hiarchie)) {

            return (
                <div className='d-flex  align-items-center'>
                    <div className='d-flex flex-column ' style={{ justifyContent: 'space-between' }}>
                        {hiarchie.map((item, index) => {
                            let isDragging = this.state.draggingStage?.id == item.stage?.id
                            let data = item.stage
                            // if (item.stage?.id == this.state.currentStage?.id) {
                            //     data = this.state.currentStage
                            // }
                            let name = checkTranslation(item.stage?.name)
                            let isSelected = this.props.currentStage?.id == item.stage?.id

                            return (
                                <div key={item.id} className='d-flex w-100 ' style={{ marginTop: 1, marginBottom: 1 }} >
                                    {item.stage?.type == 'trigger' ? (

                                        <div id={'component-' + item.stage?.id} ref={el => this['component-' + item.stage?.id] = el} className={'flexc  mr-3 my-1 position-relative ' + (this.props.currentStage == null ? '' : ' opacity-5')}>
                                            <div className="flexcc br-30" style={{ width: 32, minHeight: 32, backgroundColor: '#eee', border: '1px dashed #ccc', }}   >

                                                <img className='' src="/assets/icons/useful/stack1.png" height={22} />

                                            </div>
                                        </div>

                                    ) : (
                                        <div id={'component-' + item.stage?.id} ref={el => this['component-' + item.stage?.id] = el} className='flexc  mr-3 my-1 position-relative ' onClick={() => this.setStage(item)} style={{ opacity: (isSelected || this.props.currentStage == null) ? 1 : 0.5 }}>
                                            <div className="flexcb br-30  " style={{ padding: '6px 10px', cursor: 'move', backgroundColor: isDragging ? '#007aff30' : (data?.color?.background ?? '#fff'), color: data?.color?.text ?? '#000', border: isDragging ? '2px dashed #007aff' : '2px solid #f0f0f0', borderColor: isSelected ? '#007aff' : '#f0f0f0' }}   >
                                                <div className='w-100 '>
                                                    <p className={' font-size-12 text-bold flex-1 w-100'} style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{name}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {(item.children?.length > 0) && (

                                        this.renderSection(item.children)
                                    )}

                                    {(item.stage?.sibilings?.length > 0) && (

                                        this.renderSection(item.stage?.sibilings)
                                    )}



                                </div>
                            )
                        })}

                    </div>

                </div>
            )



        }

    }

    renderPaths = () => {
        return this.state.paths.map((prop, index) => {
            return (
                <>
                    <DiagramPath hasDropEffect={true} hideCut={true} pathColor={'#e0e0e0'} removePath={this.removePath} ref={el => this[prop.key] = el} key={prop.id} data={prop} draggingId={this.draggingId} dragEnd={this.dragEnd} onDrag={this.onDrag} onDragStart={this.onDragStart} zoom={this.state.zoom} onDrop={this.stagePathDrop} disablePathHover={true} />
                </>
            )
        })
    }


    scrollIndicatorOver = (side, value) => {

        this.container[side] = this.container[side] + value

    }



    render() {
        return (

            <div className="flexc w-100 position-relative py-1 px-1" >
                <div ref={el => this.container = el} className="flexc w-100  position-relative sc-gray2" style={{ overflow: 'auto', }} >
                    <div className='px-1 pb-3 pt-2 ' style={{ transformOrigin: '0px 0px', transform: 'scale(' + 1 + ')', }}>
                        {this.renderSection(this.state.finalHiarchie)}
                        <div className='position-absolute top-0 left-0'>
                            {this.renderPaths()}
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}

export default WorkflowViewer;